import React from 'react'

const Loading = () => {
  return (
    <div className='block-view'>
        <div className="lds-ripple"><div></div><div></div></div>
    </div>
  )
}

export default Loading